import React, { PropsWithChildren } from "react";

interface IParagraphProps {}

export const Paragraph1: React.FC<PropsWithChildren<IParagraphProps>> = ({ children }) => {
	return <div className="font-primary md:text-xl text-lg">{children}</div>;
};
export const Paragraph2: React.FC<PropsWithChildren<IParagraphProps>> = ({ children }) => {
	return <div className="font-primary md:text-xl text-lg">{children}</div>;
};

export const Paragraph3: React.FC<PropsWithChildren<IParagraphProps>> = ({ children }) => {
	return <div className="font-primary md:text-lg text-base">{children}</div>;
};

export const Paragraph4: React.FC<PropsWithChildren<IParagraphProps>> = ({ children }) => {
	return <div className="font-primary md:text-base">{children}</div>;
};
